// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsent_root__Q4B6v"};